/**
 * Maximum route-catalog ID length accepted from clients. The generated DMS catalog's observed
 * maximum is 50 characters; 100 leaves headroom for future route IDs.
 */
export const ASSISTANT_REACHABLE_ROUTE_ID_MAX_CHARACTERS = 100;
